import React, { useEffect, useState } from "react";
import "react-h5-audio-player/lib/styles.css";
import AudioPlayer from "react-h5-audio-player";
import "./App.css";

// Real stations
const STATIONS = [
  {
    id: 1,
    name: "101.5 K-Rock",
    description: "Mainstream Rock - Manhattan",
    tags: ["Rock", "Mainstream Rock"],
    image: "/stations/krock-1015.jpg",
    url: "https://stream-01.surfernetwork.com/drscz5r6naxuv?zt=eyJhbGciOiJIUzI1NiJ9.eyJzdHJlYW0iOiJkcnNjejVyNm5heHV2IiwiaG9zdCI6InN0cmVhbS0wMS5zdXJmZXJuZXR3b3JrLmNvbSIsInRtIjpmYWxzZSwicnR0bCI6NSwianRpIjoiejRVdTlWSGlRcHloZ3lLZlNiMDZGQSIsImlhdCI6MTc3NTkzNTc1NiwiZXhwIjoxNzc1OTM1ODE2fQ.xtM3hBBV3OJdYc1ITgSnPVX_bEnHy1SVtRmwF-7uQ3A",
  },
  {
    id: 2,
    name: "90.9 The Bridge",
    description: "Indie and Alternative Rock - Kansas City",
    tags: ["Rock", "Alt Rock", "Indie Rock"],
    image: "/stations/thebridge-909.jpg",
    url: "https://prod-13-222-197-5.amperwave.net/publictv19-ktbgfmaac-hlsc1.m3u8/?z=4aaa46288d4f48218b7c9f56b17116fb&p=1",
  },
  {
    id: 3,
    name: "106.7 KROQ",
    description: "Alternative Rock - Pasadena",
    tags: ["Rock", "Alt Rock"],
    image: "/stations/kroq-1067.jpg",
    url: "https://prod-18-234-58-253.amperwave.net/audacy-kroqfmaac-hlsc.m3u8",
  },
];

function App() {
  const [currentStation, setCurrentStation] = useState(STATIONS[0]);
  const [search, setSearch] = useState("");

  // theme: "light" | "dark"
  const [theme, setTheme] = useState("light");

  // if the audio player is actively playing
  const [isPlaying, setIsPlaying] = useState(false);

  // On mount: load theme from localStorage or system preference
  useEffect(() => {
    const stored = window.localStorage.getItem("catsoup-radio-theme");
    if (stored === "light" || stored === "dark") {
      setTheme(stored);
      document.documentElement.setAttribute("data-theme", stored);
      return;
    }

    const prefersDark =
        window.matchMedia &&
        window.matchMedia("(prefers-color-scheme: dark)").matches;
    const initial = prefersDark ? "dark" : "light";
    setTheme(initial);
    document.documentElement.setAttribute("data-theme", initial);
  }, []);

  const toggleTheme = () => {
    const next = theme === "light" ? "dark" : "light";
    setTheme(next);
    document.documentElement.setAttribute("data-theme", next);
    window.localStorage.setItem("catsoup-radio-theme", next);
  };

  const filteredStations = STATIONS.filter((s) =>
      (s.name + " " + s.description + " " + (s.tags || []).join(" "))
          .toLowerCase()
          .includes(search.toLowerCase())
  );

  return (
      <div className="app-root app-root--cozy">
        <div className="app-shell app-shell--cozy">
          {/* Header */}
          <header className="app-header app-header--cozy">
            <div className="app-header-left">
              <h1 className="app-title app-title--cozy">🎧🐈 Catsoup Radio</h1>
              <p className="app-subtitle app-subtitle--cozy">
                A little home‑made radio, just for you.
              </p>
            </div>

            <div className="app-header-right">
              {/* Theme toggle */}
              <button
                  type="button"
                  className="theme-toggle theme-toggle--cozy"
                  onClick={toggleTheme}
                  aria-label="Toggle light/dark theme"
              >
              <span
                  className={
                      "theme-toggle-thumb" +
                      (theme === "dark" ? " theme-toggle-thumb--right" : "")
                  }
              >
                {theme === "dark" ? "🌙" : "☀️"}
              </span>
                <span className="theme-toggle-label">
                {theme === "dark" ? "Dark" : "Light"}
              </span>
              </button>
            </div>
          </header>

          {/* Main content */}
          <main className="app-main app-main--cozy">
            {/* Stations list */}
            <section className="stations-panel stations-panel--cozy">
              <div className="panel-header panel-header--cozy">
                <h2 className="panel-title panel-title--cozy">Stations</h2>
                <span className="panel-count panel-count--cozy">
                {filteredStations.length} of {STATIONS.length}
              </span>
              </div>

              <div className="search-wrapper search-wrapper--cozy">
                <input
                    type="text"
                    placeholder="Search cozy corners…"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="search-input search-input--cozy"
                />
                <span className="search-icon search-icon--cozy">🔍</span>
              </div>

              <div className="stations-list stations-list--cozy">
                {filteredStations.map((station) => {
                  const isActive =
                      currentStation && currentStation.id === station.id;
                  return (
                      <button
                          key={station.id}
                          type="button"
                          className={
                              "station-card station-card--cozy" +
                              (isActive ? " station-card--active-cozy" : "")
                          }
                          onClick={() => setCurrentStation(station)}
                      >
                        <div className="station-card-inner">
                          {/* Thumbnail */}
                          <div className="station-thumb-wrapper">
                            {station.image ? (
                                <img
                                    src={station.image}
                                    alt={station.name}
                                    className="station-thumb"
                                />
                            ) : (
                                <div className="station-thumb-fallback">🎧</div>
                            )}
                          </div>

                          {/* Text content */}
                          <div className="station-card-content">
                            <div className="station-card-header station-card-header--cozy">
        <span className="station-name station-name--cozy">
          {station.name}
        </span>
                              {isActive && (
                                  <span className="station-badge station-badge--cozy">
            <span className="station-badge-dot station-badge-dot--cozy" />
            Now Playing
          </span>
                              )}
                            </div>

                            <p className="station-description station-description--cozy">
                              {station.description}
                            </p>

                            {station.tags && (
                                <div className="station-tags station-tags--cozy">
                                  {station.tags.map((tag) => (
                                      <span key={tag} className="station-tag station-tag--cozy">
              {tag}
            </span>
                                  ))}
                                </div>
                            )}
                          </div>
                        </div>
                      </button>
                  );
                })}
                {filteredStations.length === 0 && (
                    <p className="empty-message empty-message--cozy">
                      Nothing here yet. Try another word?
                    </p>
                )}
              </div>
            </section>

            {/* Player section */}
            <section className="player-panel player-panel--cozy">
              <div className="panel-header panel-header--cozy">
                <div>
                  <h2 className="panel-title panel-title--cozy">Now playing</h2>
                </div>
              </div>

              <div className="player-panel-body">
              {currentStation ? (
                  <>
                    <div className="now-playing-card now-playing-card--cozy">
                      <div className="artwork-placeholder artwork-placeholder--cozy">
                        {currentStation.image ? (
                            <img
                                src={currentStation.image}
                                alt={currentStation.name}
                                className="artwork-image"
                            />
                        ) : (
                            <span role="img" aria-label="Cat and music">
                              🎧🐈
                            </span>
                        )}
                      </div>
                      <div className="now-playing-info now-playing-info--cozy">
                        <div className="now-playing-header now-playing-header--cozy">
                          <h3 className="now-playing-title now-playing-title--cozy">
                            {currentStation.name}
                          </h3>
                          {isPlaying && (
                              <span className="live-pill live-pill--cozy">Live</span>
                          )}
                        </div>
                        <p className="now-playing-description now-playing-description--cozy">
                          {currentStation.description}
                        </p>
                        {currentStation.tags && (
                            <div className="now-playing-tags now-playing-tags--cozy">
                              {currentStation.tags.map((tag) => (
                                  <span
                                      key={tag}
                                      className="now-playing-tag now-playing-tag--cozy"
                                  >
                            {tag}
                          </span>
                              ))}
                            </div>
                        )}
                      </div>
                    </div>

                    <div className="player-card player-card--cozy">
                      <AudioPlayer
                          src={currentStation.url}
                          autoPlay
                          showJumpControls={false}
                          customProgressBarSection={['MAIN_CONTROLS','CURRENT_TIME']}
                          customControlsSection={['VOLUME_CONTROLS']}
                          layout="horizontal"
                          className="modern-audio-player modern-audio-player--cozy"
                          customAdditionalControls={[]}
                          onPlay={() => setIsPlaying(true)}
                          onPause={() => setIsPlaying(false)}
                          onEnded={() => setIsPlaying(false)}
                      />
                    </div>
                  </>
              ) : (
                  <p className="empty-message empty-message--cozy">
                    Choose a station to start listening.
                  </p>
              )}
              </div>
            </section>
          </main>
        </div>
      </div>
  );
}

export default App;